import * as fromRouter from "@ngrx/router-store";
import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { appSettings } from "../../environments/app-settings";
import { AppState } from "./app.state";

export const routerFeatureKey = "router";

export const reducers: ActionReducerMap<AppState> = {
    router: fromRouter.routerReducer
};

export const selectRouter = createFeatureSelector<fromRouter.RouterReducerState>(routerFeatureKey);

export const {
    selectCurrentRoute, // select the current route
    selectFragment, // select the current route fragment
    selectQueryParams, // select the current route query params
    selectQueryParam, // factory function to select a query param
    selectRouteParams, // select the current route params
    selectRouteParam, // factory function to select a route param
    selectRouteData, // select the current route data
    selectUrl // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export const metaReducers = !appSettings.production ? [] : [];
